export enum FoodOptionSelectType {
    NotAllowSelected = 0,
    AllowSelectedOne = 1,
    AllowSelectedMultiple = 2
}
